import React from "react";
import { Controller, Control, FieldValues, Path } from "react-hook-form";

interface FormControllerCheckboxProps<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  children: React.ReactElement; // The checkbox component (like MuiCheckbox)
}

export const FormControllerCheckbox = <T extends FieldValues>({
  control,
  name,
  children,
}: FormControllerCheckboxProps<T>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) =>
        React.cloneElement(children, {
          checked: field.value || false, // Ensure this gets default value
          onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
            const isChecked = event.target.checked;
            field.onChange(isChecked); // Update state
            if (children.props.onChange) {
              children.props.onChange(event); // Trigger child's onChange, if present
            }
            // Pass the custom onCheckedChange too
            if (children.props.onCheckedChange) {
              children.props.onCheckedChange(isChecked);
            }
          },
          error: fieldState?.error,
          helperText: fieldState?.error?.message,
        })
      }
    />
  );
};
